import React from "react";
// import axios from "axios"
import moment from "moment";
import cookie from "react-cookies";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { logout, getLoggedProfile } from "../../actions/sessionAct";

import { getProfile } from "../../model/profile";
import { getInfo } from "../../model/reward";
import { getUserCars } from "../../model/car";

import { LoadingPage } from "../common/loading";
import { commonErr } from "../common/errors";
import { genderMap, stypes, DriverLicenseStatus, getDriverLicenseStatus } from "../common/common";
import { MessageBox } from "../common/messagebox";

import Header from "../components/header";
import Footer from "../components/footer";
import Session from "../common/session";
import AccountSidebar from "./components/accountsidebar";
import ShareCode from "./sharecode";
import MyCard from "./mycard";

import VerifyEmail from "./verifyemail";
import VerifyPhoneOpt from "./verifyphoneopt";
import VerifyPhoneOptBreak from "./verifyphoneoptbreak";

import InfoAccount from "./infoaccount";
import ChangePhone from "./changephone";
import ChangeEmail from "./changeemail";
import ChangeDriverLicense from "./changedriverlicense";
import DriverLicense from "./driverlicense";
import License from "./license";
import ProfileReviews from "../profile/profilereviews";
import ProfileProperties from "../profile/profileproperties";

class Account extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			reviewType: 1,
			verifyPhoneNumber: "",
			verifyPhoneAccessTok: "",
			changePhone: false,
			showChangeEmail: false,
			verifyPhoneOpt: false,
			verifyEmail: false,
			showMessageBox: false,
			showChangeDriverLicense: false,
			showDriverLicense: false,
			stype: stypes.SD,
			mipoint: 0,
			totalSDCars: 0,
			totalWDCars: 0,
			sdCars: [],
			wdCars: [],
		};
	}

	componentDidMount() {
		if (this.props.session.profile.info && this.props.session.profile.info.uid) {
			this.setState({
				err: commonErr.LOADING,
			});
			getProfile(this.props.session.profile.info.uid, "pd" /*view count for server*/).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					profile: {
						...this.props.session.profile.info,
						owner: resp.data.data.profile.owner,
						traveler: resp.data.data.profile.traveler,
						timeCreated: resp.data.data.profile.timeCreated,
					},
					fullProfile: resp.data.data.profile,
					totalOwnerCars: resp.data.data.totalOwnerCars,
					cars: resp.data.data.cars,
					moreReviewFromOwner: resp.data.data.moreReviewFromOwner,
					moreReviewFromTraveler: resp.data.data.moreReviewFromTraveler,
					reviews: resp.data.data.reviews,
					profiles: resp.data.data.profiles,
				});
			});
			this.getCars(this.props.session.profile.info.uid);
		}

		this.getInfo();
	}

	componentWillReceiveProps(props) {
		if (props.session.profile.info && props.session.profile.info.uid) {
			if (
				!this.props.session.profile.info ||
				!this.props.session.profile.info.uid ||
				this.props.session.profile.info.uid !== props.session.profile.info.uid
			) {
				this.setState({
					err: commonErr.LOADING,
				});
				getProfile(props.session.profile.info.uid, "pd" /*view count for server*/).then((resp) => {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						profile: {
							...props.session.profile.info,
							owner: resp.data.data.profile.owner,
							traveler: resp.data.data.profile.traveler,
							timeCreated: resp.data.data.profile.timeCreated,
						},
						fullProfile: resp.data.data.profile,
						totalOwnerCars: resp.data.data.totalOwnerCars,
						cars: resp.data.data.cars,
						moreReviewFromOwner: resp.data.data.moreReviewFromOwner,
						moreReviewFromTraveler: resp.data.data.moreReviewFromTraveler,
						reviews: resp.data.data.reviews,
						profiles: resp.data.data.profiles,
					});
				});
				this.getCars(props.session.profile.info.uid);
			} else if (this.state.profile) {
				this.setState({
					profile: {
						...props.session.profile.info,
						owner: this.state.profile.owner,
						traveler: this.state.profile.traveler,
						timeCreated: this.state.profile.timeCreated,
					},
				});
			}
		}
	}

	getProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	getInfo = () => {
		getInfo().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					mipoint: resp.data.data.mipoint,
				});
			}
		});
	};

	getCars = (uid) => {
		getUserCars(uid, 0, 0, 0, 0, true, stypes.SD).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: resp.data.error,
					sdCars: resp.data.data.cars,
					totalSDCars: resp.data.data.totalCars,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});

		getUserCars(uid, 0, 0, 0, 0, true, stypes.WD).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					wdCars: resp.data.data.cars,
					err: resp.data.error,
					totalWDCars: resp.data.data.totalCars,
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	logout = () => {
		this.props.dispatch(logout());
	};

	showChangePaper = () => {
		this.setState({
			showChangePaper: true,
		});
	};

	hideChangePaper = () => {
		this.setState({
			showChangePaper: false,
		});
	};

	showChangePhone = () => {
		this.setState({
			changePhone: true,
		});
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_PHONE", utmExt);
		window.fbq("track", "VERIFY_PHONE");
		window.gtag("event", "VERIFY_PHONE", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	hideChangePhone = () => {
		this.setState({
			changePhone: false,
		});
	};

	showVerifyPhoneOpt = () => {
		this.setState({
			verifyPhoneOpt: true,
		});
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_PHONE_OTP", utmExt);
		window.fbq("track", "VERIFY_PHONE_OTP");
		window.gtag("event", "VERIFY_PHONE_OTP", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	hideVerifyPhoneOpt = () => {
		this.setState({
			verifyPhoneOpt: false,
		});
	};

	showVerifyPhoneOptBreak = () => {
		this.setState({
			verifyPhoneOptBreak: true,
		});
	};

	hideVerifyPhoneOptBreak = () => {
		this.setState({
			verifyPhoneOptBreak: false,
		});
	};

	showChangeEmail = () => {
		this.setState({
			showChangeEmail: true,
		});
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_EMAIL", utmExt);
		window.fbq("track", "VERIFY_EMAIL");
		window.gtag("event", "VERIFY_EMAIL", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	hideChangeEmail = () => {
		this.setState({
			showChangeEmail: false,
		});
	};

	showVerifyEmail = () => {
		this.setState({
			verifyEmail: true,
		});
	};

	hideVerifyEmail = () => {
		this.setState({
			verifyEmail: false,
		});
	};

	showChangeDriverLicense = () => {
		this.setState({
			showChangeDriverLicense: true,
		});
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		// window.ga("send", "event", utmSrc, "VERIFY_DRIVER_LICENSE", utmExt);
		window.fbq("track", "VERIFY_DRIVER_LICENSE");
		window.gtag("event", "VERIFY_DRIVER_LICENSE", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: { source: utmSrc },
		});
	};

	hideChangeDriverLicense = () => {
		this.setState({
			showChangeDriverLicense: false,
		});
	};

	openDriverLicense = (stt) => {
		if (stt === 3) {
			this.setState({
				showDriverLicense: true,
			});
		}
	};

	hideDriverLicense = () => {
		this.setState({
			showDriverLicense: false,
		});
	};

	showMessageBox = () => {
		this.setState({
			showMessageBox: true,
		});
	};

	hideMessageBox = () => {
		this.setState({
			showMessageBox: false,
		});
	};

	updatePaper = (paper) => {
		this.setState({
			paper: paper,
		});
		this.showChangePaper();
	};

	render() {
		var content;
		const {
			err,
			profile,
			mipoint,
			changePhone,
			verifyPhoneOpt,
			verifyPhoneOptBreak,
			verifyEmail,
			reviewType,
			stype,
			fullProfile,
			totalSDCars,
			totalWDCars,
			sdCars,
			wdCars,
		} = this.state;
		const { session } = this.props;

		if (
			session.profile.err === commonErr.INNIT ||
			session.profile.err === commonErr.LOADING ||
			err === commonErr.LOADING
		) {
			content = <LoadingPage />;
		} else if (profile && profile.uid) {
			const totalTrip = profile.traveler.totalTrips + profile.owner.totalTrips;
			const licenseStt = getDriverLicenseStatus(profile.driverLicenseStatus);
			const invalidSttLicense = profile.driverLicenseStatus === 0 || profile.driverLicenseStatus === 11;

			content = (
				<React.Fragment>
					<div className="content-account">
						<InfoAccount totalTrip={totalTrip} mipoint={mipoint} profile={profile} fullProfile={fullProfile} />
						<License
							profile={session.profile}
							licenseStt={licenseStt}
							driverLicense={profile.driverLicense}
							showVerifyPhone={this.showChangePhone}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>
						<ShareCode profileDetail={profile} profile={session.profile} getProfile={this.getProfile} />
						<MyCard profile={session.profile} />
						<ProfileProperties
							sdCars={sdCars}
							wdCars={wdCars}
							totalSDCars={totalSDCars}
							totalWDCars={totalWDCars}
							stype={stype}
							totalTripsFull={true}
						/>
						<ProfileReviews profile={profile} reviewType={reviewType} />
					</div>
					<ChangePhone
						show={changePhone}
						hideModal={this.hideChangePhone}
						getProfile={this.getProfile}
						showVerifyPhoneOpt={this.showVerifyPhoneOpt}
					/>
					{verifyPhoneOpt && (
						<VerifyPhoneOpt
							show={verifyPhoneOpt}
							hideModal={this.hideVerifyPhoneOpt}
							getProfile={this.getProfile}
							onBreakVerifyPhoneOtp={this.showVerifyPhoneOptBreak}
						/>
					)}
					{verifyPhoneOptBreak && (
						<VerifyPhoneOptBreak show={verifyPhoneOptBreak} hideModal={this.hideVerifyPhoneOptBreak} />
					)}

					<ChangeDriverLicense
						show={this.state.showChangeDriverLicense}
						getProfile={this.getProfile}
						profile={session.profile}
						hideModal={this.hideChangeDriverLicense}
						showVerifyPhone={this.showChangePhone}
						showVerifyPhoneOpt={this.showVerifyPhoneOpt}
					/>
					<DriverLicense
						show={this.state.showDriverLicense}
						hideModal={this.hideDriverLicense}
						data={profile.driverLicense}
					/>

					<ChangeEmail
						show={this.state.showChangeEmail}
						hideModal={this.hideChangeEmail}
						getProfile={this.getProfile}
					/>
					<VerifyEmail
						email={profile.email}
						show={verifyEmail}
						hideModal={this.hideVerifyEmail}
						getProfile={this.getProfile}
					/>
					<MessageBox show={this.state.showMessageBox} hideModal={this.hideMessageBox} message={this.state.errMsg} />
				</React.Fragment>
			);
		}

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<AccountSidebar />
								{content}
							</div>
						</div>
					</div>
				</section>
				<Footer />
			</div>
		);
	}
}

function mapState(state) {
	return {
		session: state.session,
	};
}

Account = connect(mapState)(Account);

export default Account;
